import { Skeleton } from "@/components/ui/skeleton";

export const LazyLoadingSpinner = () => (
  <div className="min-h-screen bg-background animate-in fade-in duration-300">
    {/* Navigation skeleton with shimmer effect */}
    <div className="h-16 border-b bg-background">
      <div className="container mx-auto px-4 h-full flex items-center justify-between">
        <Skeleton className="h-8 w-32 animate-pulse" />
        <div className="flex gap-4">
          <Skeleton className="h-8 w-20 animate-pulse" />
          <Skeleton className="h-8 w-20 animate-pulse" />
          <Skeleton className="h-8 w-20 animate-pulse" />
        </div>
      </div>
    </div>

    {/* Main content skeleton with staggered animation */}
    <div className="container mx-auto px-4 py-8">
      <div className="space-y-6">
        <Skeleton className="h-12 w-64 animate-pulse" />
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <div 
              key={i} 
              className="space-y-3 animate-in fade-in-50 slide-in-from-bottom-4"
              style={{ animationDelay: `${i * 50}ms`, animationFillMode: 'both' }}
            >
              <Skeleton className="h-48 w-full" />
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-4 w-1/2" />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export const AdminLoadingSpinner = () => (
  <div className="min-h-screen bg-background animate-in fade-in duration-200">
    <div className="h-16 border-b bg-background">
      <div className="container mx-auto px-4 h-full flex items-center">
        <Skeleton className="h-8 w-48 animate-pulse" />
      </div>
    </div>
    <div className="h-12 border-b bg-muted/50">
      <div className="container mx-auto px-4 h-full flex items-center gap-6">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton 
            key={i} 
            className="h-6 w-20 animate-pulse" 
            style={{ animationDelay: `${i * 50}ms` }}
          />
        ))}
      </div>
    </div>
    <div className="container mx-auto px-4 py-8">
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 9 }).map((_, i) => (
          <div 
            key={i} 
            className="space-y-3 p-6 border rounded-lg animate-in fade-in-50 slide-in-from-bottom-2"
            style={{ animationDelay: `${i * 40}ms`, animationFillMode: 'both' }}
          >
            <Skeleton className="h-6 w-6" />
            <Skeleton className="h-5 w-3/4" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-2/3" />
          </div>
        ))}
      </div>
    </div>
  </div>
);